import client, { sendToApi } from 'api/client'
import { Permission } from 'types'

export const NotificationsClient = {
  markAllAsSeen: (workspaceId: number) => {
    return sendToApi<{}>(`/w/${workspaceId}/notifications/mark_all_as_seen`, {
      method: 'PUT',
    })
  },

  markAllAsRead: (workspaceId: number) => {
    return sendToApi<{}>(`/w/${workspaceId}/notifications/mark_all_as_read`, {
      method: 'PUT',
    })
  },

  markAsRead: (notificationId: number) => {
    return sendToApi<{}>(`/inbox_items/${notificationId}/mark_read`, {
      method: 'POST',
    })
  },

  acceptAccessRequest: async (token: string, permission: Permission, addToWorkspace: boolean) => {
    return client.acceptAccessRequest(token, permission, addToWorkspace)
  },
}
